import cmge from "@/assets/images/Home/PraiseList/logo/cmge.png";
import eyewind from "@/assets/images/Home/PraiseList/logo/eyewind.png";
import minijoy from "@/assets/images/Home/PraiseList/logo/minijoy.png";
import sagigames from "@/assets/images/Home/PraiseList/logo/sagigames.png";
import tantan from "@/assets/images/Home/PraiseList/logo/tantan.png";
// import supercent from "@/assets/images/Home/PraiseList/logo/supercent.png";
import ilana from "@/assets/images/Home/PraiseList/logo/ilana.png";
import tiptop from "@/assets/images/Home/PraiseList/logo/tiptop.png";
import leiting from '@/assets/images/Home/PraiseList/logo/leiting.png'
import going from '@/assets/images/Home/PraiseList/logo/going.png'
import alictus from '@/assets/images/Home/PraiseList/logo/alictus.png'
import gamehaus from '@/assets/images/Home/PraiseList/logo/gamehaus.png'

import { chunk } from "lodash";
import i18n from "../../i18n";

const { t } = i18n

const companyListsToAlt = {
  "5game": "5game",
  "afour": "afour",
  "aidefanqie": "爱的番茄",
  "alictus": "alictus",
  "amobear": "AMOBERR STUDIO",
  "aplus": "APLUS",
  "apus": "APUS",
  "athree": "A3",
  "auroramob": "Auroramob",
  "azu": "AZURGAMWS",
  "baidu": "baidu百度",
  "baochuan": "宝船科技",
  "bingchuan": "冰川网络",
  "boke": "BOKE波克城市",
  "chicheng": "驰骋游戏",
  "cmge": "CMGE中手游",
  "cpushe": "CUPSHE",
  "dalanyouxi": "大蓝游戏",
  "eyewind": "EYEWIND",
  "fengkuang": "疯狂游戏",
  "flamesdas": "Flanesdas",
  "gamegoing": "GAMEGOING",
  "gamehaus": "Gamehaus",
  "hang": "HANG",
  "huayao": "华曜科技",
  "hyber": "HYBER MEDIA",
  "igg": "IGG",
  "ilana": "ILana",
  "iqyi": "iQIYI爱奇艺",
  "jianchuang": "简创网络",
  "jichuang": "RAYCREATOR疾创网络",
  "jiujiu": "九九互动",
  "joypac": "JoyPac",
  "junhai": "君海游戏",
  "kaixin": "kaixin",
  "leiting": "雷霆游戏",
  "lishu": "栗树科技",
  "lunplay": "伦奇游戏",
  "marature": "MIRATURE",
  "master lex": "Master Lex",
  "mele": "MELE BTUDIO",
  "mib": "MIB",
  "mike": "米壳游戏",
  "mobplus": "MOBPLUS",
  "olivemedia": "OLIVE MEDIA",
  "papa": "PaPa",
  "quanminhudong": "全民活动",
  "seven": "SEVEN PIRATES",
  "shareit": "SHAREit",
  "sharp": "sharp network",
  "shiyue": "诗悦网络",
  "sinozo": "星创信息",
  "sofish": "SOFISH",
  "supercent": "SUPERCENT",
  "superstar": "Super Star",
  "tantan": "探探",
  "tianyou": "天游网络",
  "tiptop": "TIPTOP 星奇畅想",
  "touka": "Touka",
  "udogame": "UDOGAMES",
  "vtcmobile": "VTC Moblie",
  "wanxin": "玩心不止",
  "wawayu": "哇哇鱼网络科技",
  "weiyi": "唯意科技",
  "wonder": "勇往科技",
  "wtemedia": "Wtemedia",
  "wuhanduoyou": "武汉多游",
  "xianlai": "闲徕互娱",
  "xx": "闲闲互娱",
  "yingke": "映客",
  "youlong": "游龙互娱",
  "yuntuhuyu": "云图互娱",
  "zhangzhongyun": "掌中云"
}  

const praiseList = [
  {
    text: t('home.option.list.going.text'),
    countText1: t('home.option.list.going.countText1'),
    mobileText1: t('home.option.list.going.mobileCountText1'),
    countText2: t('home.option.list.going.countText2'),
    countNum1: '15%',
    countNum2: '10%',
    down: [false,false],
    img: require('../../assets/images/More/going/going-home.jpg'),
    altText: 'GAMEGOINGbanner',
    logo: going,
    logoAlt: 'GAMEGOING',
    name: 'example.brand.item11.name',
    width: '220px',
    height: '80px'
  },
  {
    text: t('home.option.list.gamehus.text'),
    countText1: t('home.option.list.gamehus.countText1'),
    mobileText1: t('home.option.list.gamehus.mobileCountText1'),
    countText2: t('home.option.list.gamehus.countText2'),
    countNum1: '50%',
    countNum2: '30%',
    down: [true,false],
    img: require('../../assets/images/More/gamehaus/gamehaus-image.jpg'),
    altText: 'Gamehausbanner',
    logo: gamehaus,
    logoAlt: companyListsToAlt['gamehaus'],
    name: 'example.brand.item12.name',
    width: '220px',
    height: '80px'
  },
  {
    text: t('home.option.list.alictus.text'),
    countText1: t('home.option.list.alictus.countText1'),
    mobileText1: t('home.option.list.alictus.mobileCountText1'),
    countText2: t('home.option.list.alictus.countText2'),
    countNum1: '80%',
    countNum2: '39%',
    down: [true,false],
    img: require('../../assets/images/More/alictus/alictus-image.jpg'),
    altText: 'alictusbanner',
    logo: alictus,
    logoAlt: companyListsToAlt['alictus'],
    name: 'example.brand.item13.name',
    width: '220px',
    height: '80px'
  },
  {
    text: t('home.option.list.eyewind.text'),
    countText1: t('home.option.list.eyewind.countText1'),
    countText2: t('home.option.list.eyewind.countText2'),
    countNum1: '200%',
    countNum2: '36%',
    down: [false,false],
    img: require('../../assets/images/Home/PraiseList/eyewind.png'),
    altText: 'EYEWINDbanner',
    logo: eyewind,
    logoAlt: companyListsToAlt['eyewind'],
    name: 'example.brand.item3.name',
    width: '227px',
    height: '80px'
  },
  {
    text: t('home.option.list.sagigames.text'),
    countText1: t('home.option.list.sagigames.countText1'),
    countText2: t('home.option.list.sagigames.countText2'),
    countNum1: '75%',
    countNum2: '32%',
    down: [true,false],
    img: require('../../assets/images/Home/PraiseList/sagigames.png'),
    altText: 'SAGIGAMESbanner',
    logo: sagigames,
    logoAlt: 'SAGIGAMES',
    name: 'example.brand.item6.name',
    width: '220px',
    height: '82px'
  },
  {
    text: t('home.option.list.cmge.text'),
    countText1: t('home.option.list.cmge.countText1'),
    mobileText1: t('home.option.list.cmge.mobileCountText1'),
    countText2: t('home.option.list.cmge.countText2'),
    countNum1: '75%',
    countNum2: '32%',
    down: [true,false],
    img: require('../../assets/images/Home/PraiseList/cmge.png'),
    altText: 'CMGE中手游banner',
    logo: cmge,
    logoAlt: companyListsToAlt['cmge'],
    name: 'example.brand.item2.name',
    width: '220px',
    height: '80px'
  },
  {
    text: t('home.option.list.tiptop.text'),
    countText1: t('home.option.list.tiptop.countText1'),
    countText2: t('home.option.list.tiptop.countText2'),
    countNum1: '70%',
    countNum2: '200%',
    down: [true,false],
    img: require('../../assets/images/Home/PraiseList/TipTop.png'),
    altText: 'TIPTOPbanner',
    logo: tiptop,
    logoAlt: companyListsToAlt['tiptop'],
    name: 'example.brand.item10.name',
    width: '220px',
    height: '80px'
  },
  {
    text: t('home.option.list.tantan.text'),
    countText1: t('home.option.list.tantan.countText1'),
    countText2: t('home.option.list.tantan.countText2'),
    countNum1: '95%',
    countNum2: '300%',
    down: [true,false],
    img: require('../../assets/images/Home/PraiseList/tantan.png'),
    altText: '探探banner',
    logo: tantan,
    logoAlt: companyListsToAlt['tantan'],
    name: 'example.brand.item8.name',
    width: '220px',
    height: '80px'
  },
  {
    text: t('home.option.list.minijoy.text'),
    countText1: t('home.option.list.minijoy.countText1'),
    countText2: t('home.option.list.minijoy.countText2'),
    countNum1: '80%',
    countNum2: '30%',
    down: [true,false],
    img: require('../../assets/images/Home/PraiseList/minijoy.png'),
    altText: 'miniJoybanner',
    logo: minijoy,
    logoAlt: 'MinjJoy',
    name: 'example.brand.item4.name',
    width: '220px',
    height: '80px'
  },
  {
    text: t('home.option.list.ilana.text'),
    countText1: t('home.option.list.ilana.countText1'),
    countText2: t('home.option.list.ilana.countText2'),
    countNum1: '300%',
    countNum2: '40%',
    down: [false,false],
    img: require('../../assets/images/Home/PraiseList/ilana.png'),
    altText: 'iLanabanner',
    logo: ilana,
    logoAlt: companyListsToAlt['ilana'],
    name: 'example.brand.item9.name',
    width: '220px',
    height: '80px'
  },
  {
    text: t('home.option.list.leiting.text'),
    countText1: t('home.option.list.leiting.countText1'),
    mobileText1: t('home.option.list.leiting.mobileCountText1'),
    countText2: t('home.option.list.leiting.countText2'),
    countNum1: '95%',
    countNum2: '42%',
    down: [true,false],
    img: require('../../assets/images/Home/PraiseList/leiting.png'),
    altText: '雷霆游戏banner',
    logo: leiting,
    logoAlt: companyListsToAlt['leiting'],
    name: 'example.brand.item1.name',
    width: '220px',
    height: '80px'
  }
]
const brandList = [
  {
    title: t('home.company.section1'),
    list: [
      { name: 'google', altText: 'Google' },
      { name: 'meta', altText: 'Meta' },
      { name: 'tiktok', altText: 'TikTok' },
      { name: 'asa', altText: 'Search Ads' },
      { name: 'kwai', altText: 'Kwai' },
      { name: 'huawei', altText: 'Petal Ads' },
      { name: 'mtg', altText: 'Mintegral' },
      { name: 'liftoff', altText: 'Liftoff' },
      { name: 'applovin', altText: 'APPLOVIN' },
      { name: 'unity', altText: 'unity ADS' },
      { name: 'ironSource', altText: 'ironSource' },
      { name: 'snapchat', altText: 'Snapchat' },
    ].map(item => ({
      ...item,
      src: `${process.env.PUBLIC_URL}/official/brandList/${item.name}.png`
    })),
  },
  {
    title: t('home.company.section2'),
    list: [
      { name: 'appsflyer', altText: 'AppsFlyer' },
      { name: 'adjust', altText: 'ADJUST' },
      { name: 'tenjin', altText: 'tenjin' },
      { name: 'trackingio', altText: 'TRACKINGIO' },
      { name: 'solorEngine', altText: 'SolarEngine' },
      { name: 'singular', altText: 'singular' },
    ].map(item => ({
      ...item,
      src: `${process.env.PUBLIC_URL}/official/brandList/${item.name}.png`
    })),
  },
  {
    title: t('home.company.section3'),
    list: [
      { name: 'max', altText: 'MAX' },
      { name: 'topon', altText: 'topOn' },
    ].map(item => ({
      ...item,
      src: `${process.env.PUBLIC_URL}/official/brandList/${item.name}.png`
    })),
  },
  {
    title: t('home.company.section4'),
    list: [
      { name: 'shopify', altText: 'shopify' },
      { name: 'shopline', altText: 'SHOPLINE' },
      { name: 'shoplazza', altText: 'SHOPLAZZA' },
    ].map(item => ({
      ...item, 
      src: `${process.env.PUBLIC_URL}/official/brandList/${item.name}.png`,
    })),
    remark: {
      // shopline: 'SHOPLINE 数据预计将于2024年接入'
    }
  } 
]

const applications_cn = Array.from({length: 7}).map((item, index) => ({
  title: t(`home.application.list.item${index+1}`),
  img: require(`../../assets/images/Home/application/${index+1}.png`),
  altText: t(`home.application.altText.alt${index+1}`)
}))

const applications_en = [5,4,3,6,2,1,7].map((item) => ({
  title: t(`home.application.list.item${item}`),
  img: require(`../../assets/images/Home/application/${item}.png`),
  altText: t(`home.application.altText.alt${item}`)
}))


const imageContext = require.context(
  "/public/official/companyList",
  false,
  /\.(png|jpe?g|gif|svg)$/
);
const imageFileNames = imageContext.keys().map((key) => key.replace("./", ""));

const companyLists = chunk(
  imageFileNames,
  Math.ceil(imageFileNames.length / 4)
).map((item) =>
  item.map((iitem) => ({
    "src": `${process.env.PUBLIC_URL}/official/companyList/${iitem}`,
    "altText": companyListsToAlt[iitem.replace('.png', '')]
  }))
);

const protectList = [
  {
    text: t('home.protect.nda'),
    mobileText: t('home.protect.mobilenda'),
    img: require('../../assets/images/Home/protect/nda.png')
  },
  {
    text: t('home.protect.ccpa'),
    mobileText: t('home.protect.mobileccpa'),
    img: require('../../assets/images/Home/protect/ccpa.png')
  },
  {
    text: t('home.protect.ePrivacyseal'),
    img: require('../../assets/images/Home/protect/eprivacyseal.png')
  },
  {
    text: t('home.protect.aicpa'),
    img: require('../../assets/images/Home/protect/aicpa.png')
  }
]

export {
  companyLists,
  praiseList,
  applications_cn,
  applications_en,
  brandList,
  protectList
};
